import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { CommandItem } from "@tellescope/ui";
import { Users } from "lucide-react";

export interface GroupOptionProps {
  name: string;
  onSelect: (userIds: string[]) => void;
}

export const GroupOption = ({ name, onSelect }: GroupOptionProps) => {
  const groupUsersQuery = useTellescopeQuery({
    model: "users",
    method: "get_users_for_groups",
    request: { groups: [name] },
  });

  return (
    <CommandItem
      value={`group:${name}`}
      onSelect={() => onSelect(groupUsersQuery.data?.userIds ?? [])}
      className="flex items-center gap-2"
    >
      <span className="flex-shrink-0 h-6 w-6 rounded-full bg-primary/20 text-primary flex items-center justify-center">
        <Users className="h-3.5 w-3.5" />
      </span>
      <span className="truncate">{name}</span>
    </CommandItem>
  );
};
